


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    PdfViewer,
    DxScrollView,
  },
})
export default class PdfViewModal extends Vue {
    @Prop({required: false, default: 'PDF'})
    public title!: string;

    private url: string = '';
    private visible: boolean = false;
    private fullScreen: boolean = false;
    private resizing: boolean = false;

    public show(url: string) {
        this.url = url;
        this.visible = true;
    }

    public hide() {
        this.visible = false;
    }

    private toggleFullScreen() {
        this.resizing = true;
        this.fullScreen = !this.fullScreen;
        setTimeout(() => {
            this.resizing = false;
        }, 200);
    }

    get pdfSize() {
        if (this.fullScreen) {
            return window.innerHeight - 125;
        }
        return window.innerHeight - 275;
    }
}
